import { BankGatewayTypeState } from "../../enums/index";
function getBankGatewayStateText(type) {
  let result = "";
  switch (type) {
    case BankGatewayTypeState.Unknown():
      result = "نامعلوم";
      break;
    case BankGatewayTypeState.Visited():
      result = "ورود به درگاه";
      break;
    case BankGatewayTypeState.Succeeded():
      result = "موفق";
      break;
    case BankGatewayTypeState.Failed():
      result = "ناموفق";
      break;
    case BankGatewayTypeState.Canceled():
      result = "انصراف";
      break;
    case BankGatewayTypeState.Reversed():
      result = "ناموفق از طرف دفتر شما";
      break;
    default:
      result = "";
      break;
  }
  return result;
}
export default getBankGatewayStateText;
